import { Component, OnInit, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskUtility } from '../../../utility/mask-utility';
import { MaskConfig } from '../../../utility/mask-config';
import { Observable } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { FieldLabelConstants } from 'projects/bis-shared/src/lib/utility/field-label-constants';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { UserInputOptionType } from 'projects/bis-shared/src/lib/shared-models/user-input-option-type';
import { FormsModule } from '@angular/forms';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';

@Component({
  selector: 'app-insurer-external-lookup-form',
  templateUrl: './insurer-external-lookup-form.component.html',
  styleUrls: ['./insurer-external-lookup-form.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, GenericInputComponent, SelectInputComponent],
})
export class InsurerExternalLookupFormComponent extends GenericLookupForm implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);

  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  @Input() events: Observable<void>;
  formLoaded = false;
  AppUrls = AppUrls;
  feinMaskConfig: MaskConfig;
  insurerWNumberMaskConfig: MaskConfig;
  insurerBNumberMaskConfig: MaskConfig;
  inIdMaskConfig = MaskUtility.getEntityIdMask('IN');
  FieldLabelConstants = FieldLabelConstants;

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService.getFormGroupForModel('insurerExternalLookup').subscribe(formInfo => {
      this.formInfo = formInfo;
      this.form = formInfo.formGroup;
      this.markFormGroupTouched(this.form);
      this.formLoaded = true;
    });
  }

  search() {
    this.enterKey.emit();
  }

  onFeinChange() {
    this.feinMaskConfig = MaskUtility.getExternalFEINMask();
  }

  onWNumberChange() {
    this.insurerWNumberMaskConfig = MaskUtility.getInsurerWNumberMask();
  }

  onBNumberChange() {
    this.insurerBNumberMaskConfig = MaskUtility.getInsurerBNumberMask();
  }

  public isValid(): boolean {
    return this.form && this.form.valid;
  }

  public reset(): void {
    this.form.reset({
      nameSearchOptionType: UserInputOptionType.Contains,
    });
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: UntypedFormGroup) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
